import { FC } from 'react';

import { HeroSection } from 'components/HeroSection';
// import { DemoWrapper } from 'components/DemoWrapper';
import { Button } from 'components/Buttons';

import { HeroDescription, HeroTitle, WebLeft, WebRight, Wrapper } from './Hero.styles';

import WebLeftImage from 'assets/applications/web-left.webp';
import WebRightImage from 'assets/applications/web-right.webp';

import { useIsMobile } from 'hooks/useIsMobile';
import { IApplicationHeroData } from 'types/applications';
import { BOOK_A_DEMO_LINK } from 'constants/common';

const Hero: FC<IApplicationHeroData> = ({ description, title }) => {
  const isMobile = useIsMobile();

  return (
    <HeroSection>
      <Wrapper>
        <WebLeft src={WebLeftImage} alt="web" />
        <WebRight src={WebRightImage} alt="web" />
        <HeroTitle>{title}</HeroTitle>

        <HeroDescription>{description}</HeroDescription>

        <a href={BOOK_A_DEMO_LINK} target="_blank" rel="noreferrer">
          <Button width={isMobile ? 'full' : 176}>
            Book a Meeting
          </Button>
        </a>

        {/* <Box
          display="flex"
          maxWidth="1200px"
          marginTop={{
            sm: '80px',
            xxs: '48px',
          }}
        >
          <DemoWrapper textAlign="center">
            <video
              onContextMenu={preventDefaultHandler}
              preload="yes"
              ref={videoRef}
              onClick={onClick}
              title="AILiveSim Variability Demo"
              src={videoSrc}
              muted
              loop
            />
          </DemoWrapper>

          <img src={imageSrc} alt={title} style={{ maxWidth: '100%', height: 'auto' }} />
        </Box> */}
      </Wrapper>
    </HeroSection>
  );
};

export default Hero;
